export default __webpack_public_path__ + "static/media/profileMan.15422c43.svg";